import * as Gantt from "./core/gantt_factory";

const w = window as any;
w.Gantt = Gantt;
const gantt = w.gantt = Gantt.getGanttInstance();

export default gantt;
export { Gantt, gantt };
